<template>
  <div class="console-container">
    <template v-for="(log, index) of logs">
      <div class="log-entry">URL:{{ log.url }}</div>
      <div class="log-entry">Method:{{ log.method }}</div>
      <div class="log-entry">
        Total Time:
        <span :class="`status-${log.timeStatus}`"> {{ log.totalSecondsTime }} seconds</span>
      </div>
      <div class="log-entry">
        Store Procedure Time:{{ log.sprocTime?`${log.sprocTime} seconds`:'' }} 
      </div>
      <button class="collapsible" @click="collapse(`rpl-body-${index}`)">
        Body: (View details)
      </button>
      <div class="content" :id="`rpl-body-${index}`">
        <pre style="color: white">{{ jsonFormat(log.data) }}</pre>
      </div>
      <button class="collapsible" @click="collapse(`rpl-response-${index}`)">
        Response: (View details)
      </button>
      <div class="content" :id="`rpl-response-${index}`">
        <pre style="color: white">{{ jsonFormat(log.response) }}</pre>
      </div>
      <hr />
    </template>
  </div>
</template>

<script>
export default {
  name: "request-performance-logs",
  computed: {
    logs() {
      return app.requestPerformanceLogs || [];
    },
  },
  methods: {
    jsonFormat(json) {
      return JSON.stringify(json, null, 4);
    },
    collapse(id) {
      const content = document.getElementById(id);
      content.style.display =
        content.style.display === "block" ? "none" : "block";
    },
  },
};
</script>

<style scoped>
.console-container {
  font-family: monospace;
  color: #33ff33;
  background: black;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 255, 0, 0.5);
  overflow-y: auto;
  width: 90%;
  height: 100%;
}
.log-entry {
  margin: 5px 0;
}
.status-success {
  color: rgba(0, 204, 0, 0.685);
}
.status-warning {
  color: rgb(255, 229, 80);
}
.status-danger {
  color: rgb(255, 0, 0);
}
.collapsible {
  background: #111;
  border: none;
  color: #33ff33;
  padding: 5px;
  text-align: left;
  width: 100%;
  cursor: pointer;
}
.content {
  display: none;
  padding: 5px;
  background: #222;
  color: white;
  border-left: 2px solid #33ff33;
}
</style>
